/**
 * ユーザ登録
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Grid,
    FormControl,
    InputLabel,
    InputBase,
    FormControlLabel,
    Radio,
    RadioGroup,
    Typography,
    Button,
    FormHelperText,
    Paper,
    MenuList,
    MenuItem,
    DialogTitle,
    Select
} from '@material-ui/core';
import { dictionary, getUserInfo, getlangId } from 'mdoc/admin/axios'
import {
    getUserDetail,
    getDepartmentSearch,
    UserLogin,
    UserNewLogin
} from 'mdoc/admin/axios/user'
import { Link } from 'react-router-dom'
import * as config from 'mdoc/admin/axios/config'
import { messageFormat } from 'mdoc/utils'
import Dialog from 'mdoc/utils/myDialog';
import schema from 'async-validator';
import Toast from 'mdoc/utils/toast';
import {
    Close
} from '@material-ui/icons';
import $ from 'jquery';
import eventProxy from 'mdoc/utils/eventProxy'
import { clientsInfo, getPermissions } from 'mdoc/admin/axios';
import 'mdoc/admin/components/notify/notify.less';

const BootstrapInput = withStyles(theme => ({
    root: {
      'label + &': {
        marginTop: theme.spacing.unit * 3,
      },
      width:'130px'
    },
    input: {
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #ced4da',
      fontSize: 12,
      padding: '5px 6px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
  }))(InputBase);
const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    margin: {
        margin: theme.spacing.unit,
    },
    bootstrapRoot: {
        'label + &': {
            marginTop: theme.spacing.unit * 3,
        }
    },
    bootstrapInput: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da',
        padding: '5px 6px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    bootstrapFormLabel: {
        lineHeight: '30px'
    },
    bootstrapFormRadioLabel: {
        lineHeight: '30px'
    },
    Radio: {
        padding: '0px 10px'
    },
    buttonlogin: {
        marginLeft: '380px',
        marginTop: '40px'
    },
    buttoncancel: {
        marginLeft: '30px',
        marginTop: '40px'
    },
    link: {
        textDecoration: 'none'
    },
    required: {
        color: '#F72D2D'
    },
    tags: {
        margin: theme.spacing.unit,
    },
    title: {
        marginLeft: '-20px'
    },
    bootstrapSelect: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da!important',
        paddingLeft: '5px'
    }
});

class User_Edit extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            selectedRowKeys: [], // Check here to configure the default column
            data: [],
            // loading: false,
            dictWord: {
                'user_id': '',
                'contact_person_name': '',
                'email': '',
                'owner_department': '',
                'tel_no': '',
                'device_control': '',
                'registration': '',
                'message': '',
                'cancel': '',
                'close': '',
                'msg_error_not_null_with_item': '',
                'msg_error_record_exists': '',
                'department_search': '',
                'name': '',
                'department': '',
                'msg_confirm_really_registration': '',
                'msg_error_over_length_with_item': '',
                'msg_please_enter_halfwidth': '',
                'msg_please_enter_halfwidth_num': '',
                'msg_not_valid_mail_address': '',
                'user_name': '',
                'department_designation': '',
                'user_search': '',
                'valid': '',
                'invalid': '',
                'confirmation': '',
                'set_lang': '',
                'msg_warning_user_information': '',
                'yes': '',
                'msg_error_value_invalid': ''
            },
            formData: {
                userId: {
                    value: '',
                    error: false,
                    errorMsg: '',
                    disabled: false
                },
                contactPersonName: {
                    value: '',
                    error: false,
                    errorMsg: ''
                },
                email: {
                    value: '',
                    error: false,
                    errorMsg: '',
                    oldValue: ''
                },
                telNo: {
                    value: '',
                    error: false,
                    errorMsg: ''
                },
                langId: {
                    width: '',
                    value: '',
                },
                deviceControl: {
                    ruleId: config['RULE_CODE']['deviceControl'],
                    value: '1',
                    error: false,
                    errorMsg: ''
                },
                tags: {
                    value: [],
                    error: false,
                    errorMsg: ''
                },
                serverId:{
                    value: '',
                },
                syncFlg:{
                    value: '',
                }
            },
            dialogOpen: false,
            dialogOpenSearch: false,
            show: false,
            // name:'',
            departmentName: '',
            department: [],
            langIdData: [],
            disabledAll: false
    
        };
    }
    componentWillMount() {
        this.start(this.state);
        const permissions = getPermissions() !== undefined ? getPermissions() : [];
        if (!permissions.includes(3)) {
            this.setState({
                disabledAll: true
            });
        }
    }
    start = (state) => {
        // this.setState({loading: true});
        let dict = {}
        dictionary(state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord: dict,
            })
        })
        getlangId().then(res => {
            let langIdData = this.state.langIdData
            let data = res.results;
            for(let key in data){
                let val = data[key];
                langIdData.push({
                    name: val.name,
                    id: val.id
                })
            }
            this.setState({
                langIdData
            });
            
        })
        if (this.props.match.params.id !== undefined) {
            let id = this.props.match.params.id;
            this.setState({
                loading: true,
            });
            getUserDetail({
                id: id
            }).then(res => {
                const detail = res.results;
                let formData = this.state.formData;
                formData['deviceControl'] = Object.assign(this.state['formData']['deviceControl'], { value: String(detail['deviceControl']) });
                let userCode = Object.assign(this.state['formData']['userId'], { value: detail['userCode'], disabled: true });
                formData['userId'] = userCode;
                let contactPersonName = Object.assign(this.state['formData']['contactPersonName'], { value: detail['name'] });
                formData['contactPersonName'] = contactPersonName;
                let email = Object.assign(this.state['formData']['email'], { value: detail['email'], oldValue: detail['email'] });
                formData['email'] = email;
                let telNo = Object.assign(this.state['formData']['telNo'], { value: detail['phone'] });
                formData['telNo'] = telNo;
                let langId = Object.assign(this.state['formData']['langId'], { value: detail['langId'] });
                formData['langId'] = langId;
                let serverId = Object.assign(this.state['formData']['serverId'], { value: detail['serverId'] });
                formData['serverId'] = serverId;
                let dep = [];
                for (let key in detail['docMstDepartmentList']) {
                    let value = detail['docMstDepartmentList'][key];
                    dep.push({
                        id: value['id'],
                        departmentName: value['departmentName'],
                        syncFlg:value['syncFlg']
                    });
                }
                let tags = Object.assign(this.state['formData']['tags'], { value: dep });
                formData['tags'] = tags;
                this.setState({
                    loading: false,
                    formData: formData
                });
            })
        }
    }

    handleChange = (filed) => event => {
        let formData = this.state.formData;
        formData[filed] = Object.assign(this.state['formData'][filed], { value: event.target.value });
        this.setState({
            formData: formData
        });
    }
    handleDelTags = (tagid) => event => {
        let tags = this.state.formData.tags.value;
        tags.splice(tagid, 1)
        let formData = this.state.formData;
        formData['tags'] = Object.assign(this.state['formData']['tags'], { value: tags });
        this.setState({
            formData: formData
        });
    }
    handleSubmit = () => {
        let descriptor = {
            userId: [
                { required: true, message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.user_id) },
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_please_enter_halfwidth, this.state.dictWord.user_id),
                    validator(rule, value, callback, source, options) {
                        if (!/^[0-9a-zA-Z_/.-]+$/.test(value)) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
                {
                    max: 32,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.user_id)
                },
            ],
            contactPersonName: [
                { required: true, message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.contact_person_name) },
                {
                    max: 50,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.contact_person_name)
                },
            ],
            email: [
                { required: true, message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.email) },
                { type: "email", required: true, message: this.state.dictWord.msg_not_valid_mail_address },
                {
                    max: 50,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.email)
                },
            ],
            langId: [
                { required: true, message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.set_lang) },
            ],
            tags: [
                {
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.owner_department),
                    validator(rule, value, callback, source, options) {
                        if (value.length > 0) {
                            callback();
                        } else {
                            callback(new Error(rule.message));
                        }
                    }
                },
            ],
            telNo: [
                {
                    required: false,
                    message: messageFormat(this.state.dictWord.msg_please_enter_halfwidth_num, this.state.dictWord.tel_no),
                    validator(rule, value, callback, source, options) {
                        if ($.trim(value).length > 0 && !/^[0-9-/]+$/.test(value)) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
                {
                    max: 40,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.tel_no)
                },
            ]
        }
        const validator = new schema(descriptor);
        let resourceData = {};
        const formData = this.state.formData;
        for (let index in formData) {
            let item = formData[index];
            let value = item.value;
            resourceData[index] = value;
        }
        
        validator.validate(resourceData, {
            firstFields: true
        }, (errors, fields) => {
            let formData = this.state.formData;
            let emojiReg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/g;
            let emojierr = [];
            for (let index in formData) {
                formData[index] = Object.assign(this.state['formData'][index], { errorMsg: '', error: false })
                let value = formData[index].value;
                if (value && typeof value !== 'object' && value.length > 0) {
                    if (value.search(emojiReg) >= 0) {
                        emojierr.push({ 'message': this.state.dictWord.msg_error_value_invalid, 'field': index });
                    }
                }
            }
            
            if (errors || emojierr.length > 0) {
                if (errors) {
                    errors.forEach(item => {
                        formData[item.field] = Object.assign(this.state['formData'][item.field], {
                            errorMsg: item.message,
                            error: true
                        })
                    });
                }
                if (emojierr.length > 0) {
                    emojierr.forEach(item => {
                        formData[item.field] = Object.assign(this.state['formData'][item.field], {
                            errorMsg: item.message,
                            error: true
                        })
                    });
                }
                this.setState({
                    formData: formData
                });
            } else {
                this.setState({
                    dialogOpen: true,
                    formData: formData
                });
            }
        })
    }

    dialogHandleOK = (event) => {
        const confirmData = this.state.formData;
        if (this.props.match.params.id !== undefined) {
            UserNewLogin({
                'userCode': confirmData['userId']['value'],
                'id': this.props.match.params.id,
                'name': confirmData['contactPersonName']['value'],
                'email': confirmData['email']['value'],
                'phone': confirmData['telNo']['value'],
                'langId': parseInt(confirmData['langId']['value']),
                'deviceControl': parseInt(confirmData['deviceControl']['value']),
                'docMstDepartmentList': confirmData['tags']['value']
            }).then(res => {
                this.props.history.push('/admin/management/user');
            }).catch(function (error) {
                Toast.error(error);
            })
        } else {
            UserLogin({
                'userCode': confirmData['userId']['value'],
                'name': confirmData['contactPersonName']['value'],
                'email': confirmData['email']['value'],
                'phone': confirmData['telNo']['value'],
                'langId': parseInt(confirmData['langId']['value']),
                'deviceControl': getUserInfo().deviceControl === 0 ? 0 : parseInt(confirmData['deviceControl']['value']),
                'docMstDepartmentList': confirmData['tags']['value']
            }).then(res => {

                clientsInfo().then(res => {
                    eventProxy.trigger('numChange', res)
                }).catch(function (err) {
                    Toast.error(err);
                })

                // this.props.history.push('/admin/management/user');
                window.location.href = "/admin.html#/admin/management/user"
                // window.open("/admin.html#/admin/management/user")
            }).catch(function (error) {
                Toast.error(error);
            })
        }


    }
    dialogHandleClose = () => {
        this.setState({
            dialogOpen: false
        });
    }

    handleSearch = () => {
        this.setState({
            dialogOpenSearch: true,
            show: false,
            departmentName: '',
            department: []
        });
    }

    handleSearchValue = (departmentName, id) => (event) => {
        let formData = this.state.formData;
        let tags = formData.tags.value;
        let isSame = false;
        for (var key in formData['tags']['value']) {
            let value = formData['tags']['value'][key]
            if (value['id'] === id) {
                isSame = true;
                break;
            }
        }
        if (isSame) {
            Toast.info(messageFormat(this.state.dictWord.msg_error_record_exists, this.state.dictWord.department));
        } else {
            tags.push({
                id: id,
                departmentName: departmentName
            });
            formData['tags'] = Object.assign(this.state['formData']['tags'], { value: tags });
            this.setState({
                formData: formData,
                dialogOpenSearch: false
            });
        }
    }

    inputHandleSearch(event){
        this.setState({
            departmentName: event.target.value
        },()=>{
            getDepartmentSearch({
                'departmentName': this.state.departmentName,
            }).then(res => {
                this.setState({
                    show: true
                })
                const department = res.results;
                let dep = [];
                for (var key in department) {
                    let value = department[key];
                    dep.push({
                        id: value['id'],
                        departmentName: value['departmentName'],
                    });
                }
                this.setState({
                    department: dep
                })
            }).catch(function (error) {
                Toast.error(error);
            })
        });
    }
    dialogHandleOff = () => {
        this.setState({
            dialogOpenSearch: false
        });
    }
    render() {
        const { classes } = this.props;
        const { dictWord, formData } = this.state;
        return (
            <div className="mainDom" style={{minWidth: '700px'}}>
                <div className={classes.appBarSpacer} />
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="userId">
                            {dictWord.user_id}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={this.state.formData.userId.error} fullWidth>
                            <InputBase
                                id="userId"
                                value={this.state.formData.userId.value}
                                fullWidth
                                onChange={this.handleChange('userId')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                error={this.state.formData.userId.error}
                                disabled={this.state.formData.userId.disabled}
                            />
                            {this.state.formData.userId.error ? <FormHelperText id="userId-error-text">{this.state.formData.userId.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="contactPersonName">
                            {dictWord.contact_person_name}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={this.state.formData.contactPersonName.error} fullWidth>
                            <InputBase
                                id="contactPersonName"
                                value={this.state.formData.contactPersonName.value}
                                fullWidth
                                onChange={this.handleChange('contactPersonName')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                error={this.state.formData.contactPersonName.error}
                                disabled={!this.state.disabledAll?(this.props.match.params.id?(this.state.formData.serverId.value===0?false:true):false):true}
                            />
                            {this.state.formData.contactPersonName.error ? <FormHelperText id="contactPersonName-error-text">{this.state.formData.contactPersonName.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="email">
                            {dictWord.email}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={this.state.formData.email.error} fullWidth>
                            <InputBase
                                id="email"
                                value={this.state.formData.email.value}
                                fullWidth
                                onChange={this.handleChange('email')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                error={this.state.formData.email.error}
                                disabled={!this.state.disabledAll?(this.props.match.params.id?(this.state.formData.serverId.value===0?false:true):false):true}
                            />
                            {this.state.formData.email.error ? <FormHelperText id="email-error-text">{this.state.formData.email.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="ownerDepartment">
                            {dictWord.owner_department}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={this.state.formData.tags.error} fullWidth>
                            <div className="tag-list">
                                {formData.tags.value.map((column, j) => {
                                    return <span key={j} className="tags" disabled={this.state.disabledAll}>
                                        {column.departmentName}
                                        {column.syncFlg===0||column.syncFlg===undefined? <Close className="delBut" fontSize="inherit" color="action" onClick={this.props.match.params.id?(column.syncFlg===0||column.syncFlg===undefined?this.handleDelTags(j):null):this.handleDelTags(j)} />:null}
                                    </span>
                                })}
                                {/*error={this.state.formData.tags.error}*/}
                            </div>
                            {this.state.formData.tags.error ? <FormHelperText id="tags-error-text">{this.state.formData.tags.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Button variant="contained" onClick={this.handleSearch} disabled={this.state.disabledAll} className={classes.margin} style={{ backgroundColor: this.state.disabledAll ? '' : '#1769aa', color: '#fff' }}>
                            {dictWord.department_search}
                        </Button>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="telNo">
                            {dictWord.tel_no}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={this.state.formData.telNo.error} fullWidth>
                            <InputBase
                                id="telNo"
                                value={this.state.formData.telNo.value}
                                fullWidth
                                onChange={this.handleChange('telNo')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                error={this.state.formData.telNo.error}
                                disabled={!this.state.disabledAll?(this.props.match.params.id?(this.state.formData.serverId.value===0?false:true):false):true}
                            />
                            {this.state.formData.telNo.error ? <FormHelperText id="telNo-error-text">{this.state.formData.telNo.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="langId">
                            {dictWord.set_lang}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormControl error={this.state.formData.langId.error} fullWidth>
                            <Select
                                value={this.state.formData.langId.value}
                                onChange={this.handleChange('langId')}
                                id="langId"
                                name="langId"
                                input={<BootstrapInput />}
                                error={this.state.formData.langId.error}
                                disabled={this.state.disabledAll}
                            >
                                <MenuItem value="" />
                                {this.state.langIdData.map((item, index) => {
                                    return <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                })}
                            </Select>
                            {this.state.formData.langId.error ? <FormHelperText id="langId-error-text">{this.state.formData.langId.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                {getUserInfo().deviceControl === 0 ? null : <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="bootstrap-input">
                            {dictWord.device_control}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            aria-label="position"
                            name="position"
                            value={this.state.formData.deviceControl.value}
                            onChange={this.handleChange('deviceControl')}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.valid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                            <FormControlLabel
                                value="0"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.invalid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                        </RadioGroup>
                    </Grid>
                </Grid>}
                <Grid container className={classes.margin}>
                    {this.state.disabledAll ? null : <Typography variant="h5" gutterBottom className={classes.buttonlogin}>
                        <Button variant="contained" color="primary" onClick={this.handleSubmit}>
                            {dictWord.registration}
                        </Button>
                    </Typography>}
                    <Typography variant="h5" gutterBottom className={this.state.disabledAll ? classes.buttonlogin : null}>
                        <Link to="/admin/management/user" className={classes.link}>
                            <Button variant="contained" color="primary" className={classes.buttoncancel}>
                                {dictWord.cancel}
                            </Button>
                        </Link>
                    </Typography>
                </Grid>
                <Dialog
                    open={this.state.dialogOpen}
                    option={{
                        ok: {
                            text: this.state.dictWord['yes'],
                        },
                        close: {
                            text: this.state.dictWord['cancel'],
                        },
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['confirmation']}</DialogTitle>}
                    content={
                        <p>{this.state.dictWord['msg_warning_user_information']}</p>
                    }
                    handleOk={this.dialogHandleOK}
                    handleClose={this.dialogHandleClose}
                />
                <Dialog
                    open={this.state.dialogOpenSearch}
                    option={{
                        close: {
                            text: this.state.dictWord['close'],
                        },
                        maxWidth: false,
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['department_search']}</DialogTitle>}
                    content={
                        <div>
                            <div className={classes.margin}>
                                <div>
                                    <InputLabel shrink htmlFor="departmentName" className={classes.bootstrapFormLabel}>
                                        {dictWord.department_designation}
                                    </InputLabel>
                                </div>
                                <div>
                                    <InputBase
                                        style={{minWidth:'265px'}}
                                        id="departmentName"
                                        value={this.state.departmentName}
                                        fullWidth
                                        inputProps={{
                                        autoComplete:"off"
                                }}
                                        onChange={this.inputHandleSearch.bind(this)}
                                        onFocus={this.inputHandleSearch.bind(this)}
                                        classes={{
                                            root: classes.bootstrapRoot,
                                            input: classes.bootstrapInput,
                                        }}
                                    />
                                    {this.state.show ? <Paper className={classes.paper}>
                                        <MenuList>
                                            {this.state.department.map((column, j) => {
                                                return <MenuItem style={{minWidth:'230px'}} key={j} onClick={this.handleSearchValue(column.departmentName, column.id)}>{column.departmentName}</MenuItem>
                                            })}
                                        </MenuList>
                                    </Paper> : null}
                                </div>
                            </div>
                        </div>
                    }
                    handleClose={this.dialogHandleOff}
                />
            </div>
        )
    }
}

User_Edit.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(User_Edit);